<template>
  <div class="header-area">
    <div class="container-fluid">
      <div class="row menurow">
        <div class="col-2">
          <a @click="$router.go(-1)" href="javascript:;">
            <img src="/static/img/back-arrow.svg" class="pt-4 pb-4" />
          </a>
        </div>

        <div class="col-8">
          <h1 class="page-title text-center">{{ title }}</h1>
        </div>

        <div class="col-2 text-right">
          <a href v-if="hideMore != false">
            <img src="/static/img/menu-dot.svg" class="pt-4 pb-4" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["title", "hideMore"],
  data() {
    return {};
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Header.vue